import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/esnext.string.replace-all.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineAsyncComponent, defineComponent } from "vue";
//@ts-ignore
import { isArrNullOrEmpty } from "@utils/ArrayUtils";
import { mapActions, mapState, mapWritableState } from "pinia";
//@ts-ignore
import { useSearch } from "@wkComposables/useSearch";
import { Modals as _Modals } from "../Types/Modals";
//@ts-ignore
import { CONTRACT } from "@customTypes/ContractEnum";
//@ts-ignore
import { useSearchBeanPlace } from "@wkComposables/useSearchBeanPlace";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import BaseSnackbar from "@vueEntry/BaseSnackbar.vue";
//@ts-ignore
import { useBaseSnackbar } from "@wkComposables/useBaseSnackbar";
import { useCommonVars } from "@wkComposables/useCommonVars";
import { isSafari } from "@utils/DeviceDetection";
//@ts-ignore
import { redirectToValuation } from "@wkWebSrc/js/valuation/valuationCookie";
import { useSearchBeanStore } from "@store/SearchBeanStore";
import { useModalStore } from "@store/ModalStore";
import { useHomeTabStore } from "@wkWebSrc/js/store";
import { TABTYPE } from "@customTypes/HomeTabTypeEnum";
import { useListingTypologyStore } from "@store/ListingTypologyStore";
import { ArrowIcon } from "@vueEntry/SvgIcons/ArrowIcon";
var STATE;
(function (STATE) {
  STATE[STATE["HOME"] = 1] = "HOME";
  STATE[STATE["PLACE"] = 2] = "PLACE";
  STATE[STATE["MAP"] = 3] = "MAP";
  STATE[STATE["SEARCH"] = 4] = "SEARCH";
})(STATE || (STATE = {}));
export default defineComponent({
  name: "SearchMobile",
  components: {
    BaseButton: BaseButton,
    BaseSnackbar: BaseSnackbar,
    //@ts-ignore
    ValuationTypologyModal: defineAsyncComponent(function () {
      return import("@vmodals/ValuationTypologyModal.vue");
    }),
    //@ts-ignore
    ListingTypologyMultiSelectModal: defineAsyncComponent(function () {
      return import("@vmodals/ListingTypologyMultiSelectModal.vue");
    }),
    //@ts-ignore
    PlaceModal: defineAsyncComponent(function () {
      return import("@vmodals/PlaceModal.vue");
    }),
    //@ts-ignore
    MapModal: defineAsyncComponent(function () {
      return import("@vmodals/MapModal.vue");
    }),
    //@ts-ignore
    FiltersAuctionModal: defineAsyncComponent(function () {
      return import("@vmodals/FiltersAuctionModal.vue");
    }),
    //@ts-ignore
    ArrowIcon: ArrowIcon
  },
  props: {
    topCityList: {
      type: Object
    },
    typologyIdList: {
      type: Array
    },
    macrotypologyIdDefault: {
      type: Number
    },
    contractTypeDefault: {
      type: Number
    },
    valuation_tab: {
      type: Boolean,
      "default": true
    }
  },
  emits: ["is-auction-active"],
  setup: function setup() {
    var _useBaseSnackbar = useBaseSnackbar(),
      showBaseSnackbar = _useBaseSnackbar.showBaseSnackbar,
      handleShowSnackbar = _useBaseSnackbar.handleShowSnackbar,
      baseSnackbarProps = _useBaseSnackbar.baseSnackbarProps;
    var _useCommonVars = useCommonVars(),
      options = _useCommonVars.options,
      wkLabels = _useCommonVars.wkLabels,
      baseURL = _useCommonVars.baseURL,
      cdn = _useCommonVars.cdn;
    var _useSearch = useSearch(),
      search = _useSearch.search;
    var _useSearchBeanPlace = useSearchBeanPlace(),
      updateSearchBeanBySearchPlace = _useSearchBeanPlace.updateSearchBeanBySearchPlace,
      updateSearchBeanByMapPlace = _useSearchBeanPlace.updateSearchBeanByMapPlace;
    return {
      showBaseSnackbar: showBaseSnackbar,
      handleShowSnackbar: handleShowSnackbar,
      baseSnackbarProps: baseSnackbarProps,
      options: options,
      wkLabels: wkLabels,
      baseURL: baseURL,
      cdn: cdn,
      //useSearch
      search: search,
      //useSearchBeanPlace
      updateSearchBeanBySearchPlace: updateSearchBeanBySearchPlace,
      updateSearchBeanByMapPlace: updateSearchBeanByMapPlace
    };
  },
  data: function data() {
    return {
      labelSelectedMultiSelectionTypology: "",
      typologyDefault: [],
      contractDefault: 1,
      macroTypologyDefault: 1,
      place: null,
      hasPolygon: false,
      radius: 0,
      aroundMe: false,
      previouslyAroundMe: false,
      sellingIsActive: false,
      auctionIsActive: false,
      valuationTypologyId: 1,
      lastValuationTypologyId: 1,
      publicValuation: {
        realEstateValuation: {
          address: ""
        },
        privateValuation: true,
        contactDesired: null,
        email: "",
        name: "",
        surname: "",
        phone: null
      },
      loading: false,
      labelSelectedValuationTypology: ""
    };
  },
  computed: Object.assign(Object.assign(Object.assign(Object.assign({
    isDisabledBtn: function isDisabledBtn() {
      return this.sellingIsActive ? !this.valuationReady : !this.hasPlace;
    },
    Modals: function Modals() {
      return _Modals;
    },
    mapAroundYouLabel: function mapAroundYouLabel() {
      return this.wkLabels["mapAroundYou".concat(this.radius)];
    },
    currentPlaceName: function currentPlaceName() {
      var _a, _b, _c;
      var name = ((_a = this.place) === null || _a === void 0 ? void 0 : _a.displayName) || "";
      var _this$searchBean = this.searchBean,
        zoneIdList = _this$searchBean.zoneIdList,
        localityIdList = _this$searchBean.localityIdList,
        districtIdList = _this$searchBean.districtIdList,
        districtId = _this$searchBean.districtId,
        zoneId = _this$searchBean.zoneId;
      var isZoneIdListEmpty = isArrNullOrEmpty(zoneIdList);
      var isLocalityListEmpty = isArrNullOrEmpty(localityIdList);
      var areDistrictsEmpty = isArrNullOrEmpty(districtIdList);
      /* Case: whole municipality selected or city
      * ===> No zonesSelected, no districtsSelected, no localities selected
      * */
      if (isZoneIdListEmpty && !zoneId && isLocalityListEmpty && areDistrictsEmpty && !districtId && ((_b = this.place) === null || _b === void 0 ? void 0 : _b.cityID)) {
        return /\((\w+)\)/.test(this.searchBean.cityDisplayName) ? "".concat(this.searchBean.cityDisplayName || "") : "".concat(this.searchBean.cityDisplayName || "", " (").concat(this.place.provinceAcronym, ")");
      }
      if (isZoneIdListEmpty && isLocalityListEmpty && !name) return "";
      if ((districtIdList === null || districtIdList === void 0 ? void 0 : districtIdList.length) > 1 && !(zoneIdList === null || zoneIdList === void 0 ? void 0 : zoneIdList.length) && !zoneId) {
        name = this.searchBean.cityDisplayName || "";
        name += " - " + (districtIdList === null || districtIdList === void 0 ? void 0 : districtIdList.length) + " " + this.labels.zones;
      } else if ((districtIdList === null || districtIdList === void 0 ? void 0 : districtIdList.length) === 1 && !(zoneIdList === null || zoneIdList === void 0 ? void 0 : zoneIdList.length) && !zoneId) {
        name = this.searchBean.cityDisplayName || "";
        name += " - " + ((_c = this.place) === null || _c === void 0 ? void 0 : _c.districtName);
      } else if ((districtIdList === null || districtIdList === void 0 ? void 0 : districtIdList.length) >= 1 && ((zoneIdList === null || zoneIdList === void 0 ? void 0 : zoneIdList.length) > 1 || zoneId)) {
        var totalZones = ((zoneIdList === null || zoneIdList === void 0 ? void 0 : zoneIdList.length) || 1) + (districtIdList === null || districtIdList === void 0 ? void 0 : districtIdList.length);
        name = this.searchBean.cityDisplayName || "";
        name += " - " + totalZones + " " + this.labels.zones;
      } else if (zoneIdList && zoneIdList.length > 1) {
        name = this.searchBean.cityDisplayName || "";
        name += " - " + zoneIdList.length + " " + this.labels.zones;
      } else if (localityIdList && localityIdList.length > 1) {
        name = this.searchBean.cityDisplayName || "";
        name += " - " + localityIdList.length + " " + this.labels.zones;
      }
      return name;
    },
    closeOnYouURL: function closeOnYouURL() {
      return this.urlFromLabel("closeOnYou");
    },
    drawOnMapURL: function drawOnMapURL() {
      return this.urlFromLabel("drawOnMap");
    },
    searchByZoneURL: function searchByZoneURL() {
      return this.urlFromLabel("searchByZone");
    },
    valuationReady: function valuationReady() {
      var _a;
      return !!this.valuationTypologyId && !!((_a = this.place) === null || _a === void 0 ? void 0 : _a.address);
    },
    listingTypologies: function listingTypologies() {
      return this.getOptions("listingTypologies");
    },
    enumContract: function enumContract() {
      return CONTRACT;
    },
    isAuctionActive: function isAuctionActive() {
      return this.isTabActive(TABTYPE.AUCTION);
    },
    icon: function icon() {
      return this.updateIcon();
    },
    showValuation: function showValuation() {
      return window["_showValuation"];
    },
    labels: function labels() {
      return this.wkLabels;
    },
    isDisabled: function isDisabled() {
      if (this.sellingIsActive) {
        return !this.valuationReady;
      }
      return !this.hasPlace;
    }
  }, mapState(useSearchBeanStore, ["searchBean", "hasPlace", "realEstateCounter"])), mapState(useModalStore, ["showModal"])), mapState(useListingTypologyStore, ["selectedTypologiesLabel"])), mapWritableState(useHomeTabStore, ["activeTab"])),
  created: function created() {
    if (window.location.href.includes("affitto-case")) {
      this.activeTab = TABTYPE.RENT;
      this.updateContractType(CONTRACT.RENT);
    }
    if (window.location.href.includes("asta-case")) {
      this.activeTab = TABTYPE.AUCTION;
      this.updateContractType(CONTRACT.AUCTION);
    }
    this.initListingTypologyStore(JSON.parse(JSON.stringify(this.listingTypologies)));
    this.labelSelectedMultiSelectionTypology = this.selectedTypologiesLabel;
  },
  mounted: function mounted() {
    var _this = this;
    var _a, _b;
    //this.labelSelectedMultiSelectionTypology = this.options.listingTypologies[0]?.labelSelected ?? "Case - Qualsiasi";
    this.labelSelectedValuationTypology = (_b = (_a = this.options.residentialTypologiesFiltered[0]) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : "Appartamento";
    this.typologyDefault = this.typologyIdList;
    this.contractDefault = this.contractTypeDefault;
    this.macroTypologyDefault = this.macrotypologyIdDefault;
    window.onpopstate = function () {
      var showModal = _this.showModal;
      switch (showModal) {
        case _Modals.noModal:
          break;
        case _Modals.mapModal:
          {
            _this.closeMapModal();
            break;
          }
        case _Modals.placeModal:
          {
            _this.closeModal();
            break;
          }
        default:
          {
            break;
          }
      }
    };
    if (isSafari()) {
      window.onpageshow = function (event) {
        if (event.persisted) {
          this.loading = true;
          this.loading = false;
        }
      };
    }
  },
  methods: Object.assign(Object.assign(Object.assign(Object.assign({
    urlFromLabel: function urlFromLabel(label) {
      if (!this.wkLabels[label]) return "";
      return this.wkLabels[label].replaceAll(" ", "-").trim().toLowerCase();
    },
    openModal: function openModal(modal) {
      this.setShowModal(modal);
    },
    closeModal: function closeModal() {
      this.setShowModal(_Modals.noModal);
      window.history.replaceState(STATE.HOME, "", this.baseURL);
    },
    openPlaceModal: function openPlaceModal() {
      this.openModal(_Modals.placeModal);
      window.history.pushState(STATE.PLACE, "", this.baseURL + "/#" + this.searchByZoneURL);
    },
    openMapModal: function openMapModal(obj) {
      this.aroundMe = obj.aroundMe;
      this.openModal(_Modals.mapModal);
      this.aroundMe ? window.history.pushState(STATE.MAP, "", this.baseURL + "/#" + this.closeOnYouURL) : window.history.pushState(STATE.MAP, "", this.baseURL + "/#" + this.drawOnMapURL);
    },
    closeMapModal: function closeMapModal() {
      this.closeModal();
      if (!this.isDesktopMode) {
        this.openPlaceModal();
      }
    },
    getPlaceFromModal: function getPlaceFromModal(obj) {
      this.closeModal();
      if (!obj.place) return;
      this.place = obj.place;
      this.updateSearchBeanBySearchPlace(obj, false);
    },
    getPlaceFromMapModal: function getPlaceFromMapModal(obj) {
      this.closeModal();
      this.previouslyAroundMe = this.aroundMe;
      this.aroundMe = obj.aroundMe;
      this.radius = obj.radius;
      this.updateSearchBeanByMapPlace({
        polygon: obj.polygon,
        polygonForDB: obj.polygonForDB
      });
    },
    setRadiusAroundMe: function setRadiusAroundMe(obj) {
      this.radius = obj.radius;
      this.setSearchBeanByKey({
        key: "polygonFromMap",
        value: obj.polygon
      });
    },
    handleSearch: function handleSearch(e) {
      //@ts-ignore
      if (!this.hasPlace) return;
      this.search();
    },
    updateContractType: function updateContractType(contractType) {
      switch (contractType) {
        case CONTRACT.SALE:
          this.updateSearchBean({
            sale: true,
            rent: false,
            contractType: CONTRACT.SALE,
            auctionType: 0
          });
          this.sellingIsActive = false;
          this.auctionIsActive = false;
          /* Setting the tab */
          this.activeTab = TABTYPE.SALE;
          break;
        case CONTRACT.RENT:
          this.updateSearchBean({
            sale: false,
            rent: true,
            contractType: CONTRACT.RENT,
            auctionType: 0
          });
          this.sellingIsActive = false;
          this.auctionIsActive = false;
          this.activeTab = TABTYPE.RENT;
          break;
        case CONTRACT.AUCTION:
          this.updateSearchBean({
            sale: false,
            rent: false,
            contractType: CONTRACT.AUCTION,
            auctionType: 1
          });
          this.auctionIsActive = true;
          this.sellingIsActive = false;
          this.activeTab = TABTYPE.AUCTION;
          break;
        case CONTRACT.SELLING:
          this.updateSearchBean({
            sale: false,
            rent: false
          });
          this.sellingIsActive = true;
          this.auctionIsActive = false;
          this.valuationTypologyId = this.lastValuationTypologyId;
          this.activeTab = TABTYPE.SELLING;
          break;
        default:
          this.updateSearchBean({
            sale: true,
            rent: false,
            contractType: CONTRACT.SALE
          });
          this.activeTab = TABTYPE.SALE;
      }
      this.$emit("is-auction-active", this.auctionIsActive);
      this.vibrate();
    },
    getOptions: function getOptions(key) {
      return window["_options"][key];
    },
    vibrate: function vibrate() {
      try {
        if (window.navigator) {
          navigator.vibrate(50);
        }
      } catch (_a) {
        console.error("vibration not supported here");
      }
    },
    manageClick: function manageClick() {
      if (this.isDisabled) {
        this.handleShowSnackbar({
          title: "Attenzione",
          body: "Seleziona almeno un place",
          type: "warning"
        });
        return;
      }
      this.loading = true;
      this.sellingIsActive ? redirectToValuation(this.place, this.valuationTypologyId, true) : this.handleSearch();
    },
    manageSelectedTypology: function manageSelectedTypology(valuationTypology) {
      this.lastValuationTypologyId = valuationTypology.id;
      this.valuationTypologyId = this.lastValuationTypologyId;
      this.labelSelectedValuationTypology = valuationTypology.label;
    }
  }, mapActions(useSearchBeanStore, ["setSearchBean", "setSearchBeanByKey", "updateSearchBean", "updateRESBCounter"])), mapActions(useModalStore, ["setShowModal"])), mapActions(useHomeTabStore, ["isTabActive"])), mapActions(useListingTypologyStore, ["initListingTypologyStore"]))
});